export default __webpack_public_path__ + "static/media/Paved.2894ac8b.png";